import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  DocumentsDataSource,
  TupDocument,
  TupDocumentEvent,
  TupDocumentEventEmitterDirective,
  TupDocumentEventType,
  TupDocumentStorageComponent,
} from '@telmar-global/tup-document-storage';
import { SurveyTimeDocument } from 'src/app/models';

@Component({
  selector: 'app-quick-report-list',
  templateUrl: './quick-report-list.component.html',
  styleUrls: ['./quick-report-list.component.scss'],
})
export class QuickReportListComponent implements OnInit, AfterViewInit {
  @ViewChild(TupDocumentEventEmitterDirective, { static: true })
  public documentEventEmitter: TupDocumentEventEmitterDirective;
  public quickReportDataSources: DocumentsDataSource;

  @ViewChild('myQuickReports') public quickReports: TupDocumentStorageComponent;

  @Output()
  navigateToReportsTab: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  createQuickReport: EventEmitter<null> = new EventEmitter<null>();

  public eventType: TupDocumentEventType = TupDocumentEventType.CLICK;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.documentEventEmitter.click.subscribe((event: TupDocumentEvent) => {
      this.openExisting(event.document);
    });
  }

  public ngAfterViewInit(): void {
    this.quickReportDataSources = this.quickReports?.dataSource;
  }

  public openExisting(doc: TupDocument<unknown>): void {
    const currentDoc = Object.assign(doc) as TupDocument<SurveyTimeDocument>;
    this.router.navigate([`doc/${currentDoc.metadata.id}/chart`]);
    return;
  }
}
